export default __webpack_public_path__ + "static/media/whatsapp.d1038eb1.png";